<div class="page-layout carded fullwidth">
  <div class="center">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h1" [translate]="'MAINTENANCES_REPORT.TITLE'"> Dashboard </span>

      <div class="page-buttons" fxHide.xs>
        <mat-slide-toggle
          labelPosition="before"
          matTooltip="{{ 'MAINTENANCES_REPORT.AUTORELOAD_TIME' | translate }}"
          (change)="updateAutoRefreshState({ enabled: $event.checked })"
          [checked]="false"
        >
          {{ 'MAINTENANCES_REPORT.AUTORELOAD' | translate }}
        </mat-slide-toggle>

        <button
          mat-stroked-button
          matTooltip="{{ 'MAINTENANCES_REPORT.RELOAD' | translate }}"
          (click)="reload()"
          [disabled]="isLoading"
        >
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>

        <button
          *ngIf="isFilterOn"
          mat-stroked-button
          matTooltip="{{ 'MAINTENANCES_REPORT.FILTERS.CLEAR' | translate }}"
          [disabled]="isLoading"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>
      </div>

      <div class="page-buttons" fxShow="false" fxShow.xs>
        <button mat-stroked-button [matMenuTriggerFor]="menuDashboard">
          <mat-icon class="accent-500-fg">keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menuDashboard>
          <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="reload()" [disabled]="isLoading">
            <i class="angularjs-fuse-icon icon-reload small mr-4"></i>
            <span [translate]="'MAINTENANCES_REPORT.RELOAD'">Reload</span>
          </button>

          <button
            *ngIf="isFilterOn"
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="clearFilters()"
            [disabled]="isLoading"
          >
            <i class="angularjs-fuse-icon icon-filter-remove small mr-4"></i>
            <span [translate]="'MAINTENANCES_REPORT.FILTERS.CLEAR'">Clear filters</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="dashboard">
      <div class="filter">
        <div class="filter__header" [class.expanded]="isFilterExpanded" (click)="isFilterExpanded = !isFilterExpanded">
          <div class="filter__header-title">
            <mat-icon class="filter__header-title__icon">filter_alt</mat-icon>
            {{ 'MAINTENANCES_REPORT.FILTERS.TITLE' | translate }}
          </div>

          <div class="filter__header-expand">
            {{
              (isFilterExpanded ? 'MAINTENANCES_REPORT.FILTERS.SEE_LESS' : 'MAINTENANCES_REPORT.FILTERS.SEE_MORE')
                | translate
            }}
          </div>
        </div>
        <div class="filter__content" *ngIf="isFilterExpanded">
          <div class="filter__content-gap-column">
            <div class="filter__content-row">
              <div class="row__item">
                <div class="color-gray text-align-end margin-right">Data de abertura</div>
                <fc-date-input
                  [control]="filterForm.get('openedAtGte')"
                  [placeholder]="'MAINTENANCES_REPORT.FILTERS.DATE_PLACEHOLDER' | translate"
                  translateErrorPrefix="MAINTENANCES_REPORT.ERRORS"
                  [max]="filterForm.get('openedAtLte').value"
                ></fc-date-input>
                <div class="margin-left margin-right color-gray">até</div>
                <fc-date-input
                  [control]="filterForm.get('openedAtLte')"
                  [placeholder]="'MAINTENANCES_REPORT.FILTERS.DATE_PLACEHOLDER' | translate"
                  translateErrorPrefix="MAINTENANCES_REPORT.ERRORS"
                  [min]="filterForm.get('openedAtGte').value"
                ></fc-date-input>
              </div>
            </div>

            <div class="filter__content-row">
              <div class="row__item">
                <div class="color-gray text-align-end margin-right">Data de agendamento</div>
                <fc-date-input
                  [control]="filterForm.get('scheduledAtGte')"
                  [placeholder]="'MAINTENANCES_REPORT.FILTERS.DATE_PLACEHOLDER' | translate"
                  translateErrorPrefix="MAINTENANCES_REPORT.ERRORS"
                  [max]="filterForm.get('scheduledAtLte').value"
                ></fc-date-input>
                <div class="margin-left margin-right color-gray">até</div>
                <fc-date-input
                  [control]="filterForm.get('scheduledAtLte')"
                  [placeholder]="'MAINTENANCES_REPORT.FILTERS.DATE_PLACEHOLDER' | translate"
                  translateErrorPrefix="MAINTENANCES_REPORT.ERRORS"
                  [min]="filterForm.get('scheduledAtGte').value"
                ></fc-date-input>
              </div>
            </div>

            <div class="filter__content-row">
              <div class="row__item">
                <div class="color-gray text-align-end margin-right">Data de conclusão</div>
                <fc-date-input
                  [control]="filterForm.get('closedAtGte')"
                  [placeholder]="'MAINTENANCES_REPORT.FILTERS.DATE_PLACEHOLDER' | translate"
                  translateErrorPrefix="MAINTENANCES_REPORT.ERRORS"
                  [max]="filterForm.get('closedAtLte').value"
                ></fc-date-input>
                <div class="margin-left margin-right color-gray">até</div>
                <fc-date-input
                  [control]="filterForm.get('closedAtLte')"
                  [placeholder]="'MAINTENANCES_REPORT.FILTERS.DATE_PLACEHOLDER' | translate"
                  translateErrorPrefix="MAINTENANCES_REPORT.ERRORS"
                  [min]="filterForm.get('closedAtGte').value"
                ></fc-date-input>
              </div>
            </div>
          </div>

          <div class="filter__content-gap-column">
            <div class="filter__content-row">
              <div class="row__item">
                <fc-locations-input [control]="filterForm.get('locations')"></fc-locations-input>
              </div>
            </div>

            <div class="filter__content-row">
              <div class="row__item">
                <fc-maintenance-types-input [control]="filterForm.get('maintenanceTypes')"></fc-maintenance-types-input>
                <fc-segments-input [control]="filterForm.get('segments')"></fc-segments-input>
              </div>
            </div>

            <div class="filter__content-row">
              <div class="row__item">
                <fc-location-groups-input [control]="filterForm.get('locationGroups')"></fc-location-groups-input>
                <fc-companies-input [control]="filterForm.get('companies')"></fc-companies-input>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="dashboard__card">
        <div class="dashboard__card__header">
          <span class="dashboard__card__header__title">{{ 'MAINTENANCES_REPORT.STATUSES.TITLE' | translate }}</span>
          <span class="dashboard__card__header__description">
            {{ 'MAINTENANCES_REPORT.STATUSES.DESCRIPTION' | translate }}
          </span>
        </div>

        <div class="dashboard__card__situation">
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.STATUSES.CARDS.TOTAL' | translate"
            [value]="totalMaintenances"
            [isLoading]="isLoading"
            (clickSeeMore)="goToMaintenances()"
            color="#135AC0"
            [seeMore]="true"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.STATUSES.CARDS.NEW' | translate"
            [value]="status.new"
            [isLoading]="isLoading"
            (clickSeeMore)="goToMaintenances(['new'], true)"
            color="#9BC758"
            [seeMore]="true"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.STATUSES.CARDS.PENDING' | translate"
            [value]="status.pending"
            [isLoading]="isLoading"
            (clickSeeMore)="goToMaintenances(['pending'], true)"
            color="#5797E3"
            [seeMore]="true"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.STATUSES.CARDS.REQUESTED' | translate"
            [value]="status.requested"
            [isLoading]="isLoading"
            (clickSeeMore)="goToMaintenances(['requested'], true)"
            color="#1A409E"
            [seeMore]="true"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.STATUSES.CARDS.ON_NEGOTIATION' | translate"
            [value]="status.onNegotiation"
            [isLoading]="isLoading"
            (clickSeeMore)="goToMaintenances(['onNegotiation'], true)"
            color="#606060"
            [seeMore]="true"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.STATUSES.CARDS.SCHEDULED' | translate"
            [value]="status.scheduled"
            [isLoading]="isLoading"
            (clickSeeMore)="goToMaintenances(['scheduled'], true)"
            color="#1A61F7"
            [seeMore]="true"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.STATUSES.CARDS.IN_PROGRESS' | translate"
            [value]="status.inProgress"
            [isLoading]="isLoading"
            (clickSeeMore)="goToMaintenances(['inProgress'], true)"
            color="#E2772E"
            [seeMore]="true"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.STATUSES.CARDS.DONE' | translate"
            [value]="status.done"
            [isLoading]="isLoading"
            (clickSeeMore)="goToMaintenances(['done'], true)"
            color="#2FB688"
            [seeMore]="true"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.STATUSES.CARDS.REPORTED' | translate"
            [value]="status.reported"
            [isLoading]="isLoading"
            (clickSeeMore)="goToMaintenances(['reported'], true)"
            color="#F6474C"
            [seeMore]="true"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.STATUSES.CARDS.CANCELED' | translate"
            [value]="status.canceled"
            [isLoading]="isLoading"
            (clickSeeMore)="goToMaintenances(['canceled'], true)"
            color="#B560B1"
            [seeMore]="true"
          >
          </fc-data-card>
        </div>
      </div>

      <div class="dashboard__card">
        <div class="dashboard__card__header">
          <span class="dashboard__card__header__title">{{ 'MAINTENANCES_REPORT.AVERAGE_TIME.TITLE' | translate }}</span>
          <span class="dashboard__card__header__description">{{
            'MAINTENANCES_REPORT.AVERAGE_TIME.DESCRIPTION' | translate
          }}</span>
        </div>

        <div class="dashboard__card__average-time">
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.AVERAGE_TIME.CARDS.PENDING.TITLE' | translate"
            [value]="accountMaintenancesStatusInterval.pending | formatDuration: 'seconds'"
            [isLoading]="isLoading"
            color="#5797E3"
            [seeMore]="false"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.AVERAGE_TIME.CARDS.SCHEDULED.TITLE' | translate"
            [value]="accountMaintenancesStatusInterval.scheduled | formatDuration: 'seconds'"
            [isLoading]="isLoading"
            color="#1A61F7"
            [seeMore]="false"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.AVERAGE_TIME.CARDS.REQUESTED.TITLE' | translate"
            [value]="accountMaintenancesStatusInterval.requested | formatDuration: 'seconds'"
            [isLoading]="isLoading"
            color="#1A409E"
            [seeMore]="false"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.AVERAGE_TIME.CARDS.ON_NEGOTIATION.TITLE' | translate"
            [value]="accountMaintenancesStatusInterval.onNegotiation | formatDuration: 'seconds'"
            [isLoading]="isLoading"
            color="#606060"
            [seeMore]="false"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.AVERAGE_TIME.CARDS.IN_PROGRESS.TITLE' | translate"
            [value]="accountMaintenancesStatusInterval.inProgress | formatDuration: 'seconds'"
            [isLoading]="isLoading"
            color="#E2772E"
            [seeMore]="false"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.AVERAGE_TIME.CARDS.REPORTED.TITLE' | translate"
            [value]="accountMaintenancesStatusInterval.reported | formatDuration: 'seconds'"
            [isLoading]="isLoading"
            color="#F6474C"
            [seeMore]="false"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.AVERAGE_TIME.CARDS.AVERAGE_TIME_ANSWER.TITLE' | translate"
            [value]="accountMaintenancesStatusInterval.responseAverage | formatDuration: 'seconds'"
            [isLoading]="isLoading"
            color="#135AC0"
            [info]="'MAINTENANCES_REPORT.AVERAGE_TIME.CARDS.AVERAGE_TIME_ANSWER.INFO' | translate"
            [seeMore]="false"
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.AVERAGE_TIME.CARDS.AVERAGE_TIME_SOLUTION.TITLE' | translate"
            [value]="accountMaintenancesStatusInterval.solutionAverage | formatDuration: 'seconds'"
            [isLoading]="isLoading"
            color="#135AC0"
            [info]="'MAINTENANCES_REPORT.AVERAGE_TIME.CARDS.AVERAGE_TIME_SOLUTION.INFO' | translate"
            [seeMore]="false"
          >
          </fc-data-card>
        </div>
      </div>

      <div class="dashboard__card">
        <div class="dashboard__card__header">
          <span class="dashboard__card__header__title">{{ 'MAINTENANCES_REPORT.VOLUME.TITLE' | translate }}</span>
          <span class="dashboard__card__header__description">{{
            'MAINTENANCES_REPORT.VOLUME.DESCRIPTION' | translate
          }}</span>
        </div>

        <div class="dashboard__card__volume">
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.VOLUME.CARDS.ACCEPTED_MAINTENANCES' | translate"
            [value]="accountMaintenancesVolumeCount?.acceptedCount.value"
            [isLoading]="isLoading"
            color="#0055FF"
            [description]="
              'MAINTENANCES_REPORT.VOLUME.CARDS.DESCRIPTION.TOTAL'
                | translate: { percent: accountMaintenancesVolumeCount?.acceptedCount.percent }
            "
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.VOLUME.CARDS.REFUSED_MAINTENANCES' | translate"
            [value]="accountMaintenancesVolumeCount?.refusedCount.value"
            [isLoading]="isLoading"
            color="#C15EB4"
            [description]="
              'MAINTENANCES_REPORT.VOLUME.CARDS.DESCRIPTION.TOTAL'
                | translate: { percent: accountMaintenancesVolumeCount?.refusedCount.percent }
            "
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.VOLUME.CARDS.DONE_MAINTENANCES' | translate"
            [value]="accountMaintenancesVolumeCount?.completedCount.value"
            [isLoading]="isLoading"
            color="#2FB688"
            [description]="
              'MAINTENANCES_REPORT.VOLUME.CARDS.DESCRIPTION.DONE'
                | translate: { percent: accountMaintenancesVolumeCount?.completedCount.percent }
            "
          >
          </fc-data-card>
          <fc-data-card
            [title]="'MAINTENANCES_REPORT.VOLUME.CARDS.NOT_DONE_MAINTENANCES' | translate"
            [value]="accountMaintenancesVolumeCount?.incompleteCount.value"
            [isLoading]="isLoading"
            color="#FC3868"
            [description]="
              'MAINTENANCES_REPORT.VOLUME.CARDS.DESCRIPTION.DONE'
                | translate: { percent: accountMaintenancesVolumeCount?.incompleteCount.percent }
            "
          >
          </fc-data-card>
        </div>
      </div>
    </div>
  </div>
</div>
